import { SvgIcon } from '@/components/SvgIcon';
import { getTargetLogo } from '@/blocks/Scraper/constants/targets';
import { Target } from './constants/targets';

export const TargetIcon = ({ target }: { target: Target }) => {
  const logoSrc = getTargetLogo(target);

  return (
    <div className='shadow-tiny-d bg-base-white flex shrink-0 items-center justify-center overflow-hidden rounded-full'>
      {logoSrc && <SvgIcon src={logoSrc} asImg className='h-8 w-8 rounded-full' />}
    </div>
  );
};
